﻿export interface IRccapSecondaryCause {
    id: number;
    description: string;
}
